import React, { forwardRef, ReactNode, MouseEvent } from 'react';
import classnames from 'classnames';

// @ts-ignore
import styles from './InputWithIcon.scss';

export type InputWithIconProps = JSX.IntrinsicElements['input'] & {
  onIconClick?: () => void;
  children: ReactNode;
  isError?: boolean;
};

export const InputWithIcon = forwardRef<HTMLInputElement, InputWithIconProps>(
  ({ onIconClick, type = 'text', isError = false, className, children, ...props }, ref) => {
    const handleClick = (e: MouseEvent) => {
      e.stopPropagation();
      if (onIconClick) {
        onIconClick();
      }
    };

    return (
      <div className={classnames(styles.inputWithIconContainer, { [styles.invalid]: isError }, className)}>
        <input {...props} ref={ref} type={type} className={styles.inputWithIcon} />
        <i onClick={handleClick} className={styles.icon}>
          {children}
        </i>
      </div>
    );
  },
);
